module.exports = __webpack_public_path__ + "static/media/pic03.d9bf9466.gif";